<template>
  <div>
    <base-crud
      crudName="Adicionais da Sala"
      newText="Novo Adicional de Sala"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "roomsDetailsTable",
      // pages: [],
      // url: '',
      columns: ["id", "title", "pre_selected", "company_id", "actions"],
      tableData: ["id", "title", "pre_selected", "company_id"],
      options: {
        sortable: ["id", "title", "pre_selected", "company_id"],
        filterable: ["id", "title", "pre_selected", "company_id"],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          pre_selected: "Pré selecionado",
          company_id: "Empresa",
          actions: "Ações",
        },
        templates: {
          pre_selected: function (h, row, index) {
            return row.pre_selected == 1 ? "Sim" : "Não";
          },
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];
          requestData.params.with = ["company"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "room_details/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        company_id: "company[company_name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/RoomsDetails/Crud.vue